import { ApiStatus } from 'Constants';
import * as configSeeds from './seeds/config';
const handleConfig = () => {
    return {
        status: ApiStatus.OK,
        data: configSeeds.getConfig(),
    };
};
export const configHandlers = [
    {
        match: /config$/,
        handle: handleConfig,
        method: 'GET',
        name: 'config/base',
    },
];
